import { EntityTemplateVariables } from '@tools/interfaces/template';
import { getActivityFieldsForEntity } from '@tools/config/template-activity';
import { getActivityGroupFieldsForEntity } from '@tools/config/template-activity-group';
import { getContactFieldsForEntity } from '@tools/config/template-contact';

export const templateWaitingContact: EntityTemplateVariables = {
  fields: [],
  related: [
    {
      relationName: 'bpcActivity',
      relationType: 'simple',
      label: 'templates.waiting_lists.activity.label',
      description: 'templates.waiting_lists.activity.description',
      fields: getActivityFieldsForEntity('activity_group_waiting_contact.activityGroup.'),
    },
    {
      relationName: 'activityGroup',
      relationType: 'simple',
      label: 'templates.waiting_lists.activity_group.label',
      description: 'templates.waiting_lists.activity_group.description',
      fields: getActivityGroupFieldsForEntity('activity_group_waiting_contact.'),
    },
    {
      relationName: 'contact',
      relationType: 'simple',
      label: 'templates.waiting_lists.contact.label',
      description: 'templates.waiting_lists.contact.description',
      fields: getContactFieldsForEntity('activity_group_waiting_contact.'),
    },
  ],
  relatedInLoop: [],
};
